<template>
  <div class="cd_donate-container text-center py-5">
    <div class="cd_donate">
      <p>Your support helps <a href="https://deckerscreek.org/donate">Friends of Deckers Creek</a> sustain and manage the quality of the Deckers Creek watershed, providing a community asset for recreation and education for generations to come. </p>
      <a href="https://deckerscreek.org/donate" class="btn btn-lg btn-info">Donate</a>
    </div>

  </div>
</template>


<script>
  export default {
    name: 'Donate'
  }
</script>
